import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledMobileProductCategoriesCarousel = styled.div`
  display: none;
  flex-direction: column;
  background-color: ${(props) => props.theme.white};

  .title {
    text-align: left;
    padding-bottom: 15px;
    font-weight: 600;
    font-size: 18px;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .title {
      h1 {
        font-size: 1.125rem !important;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    padding: 0 20px;
    padding-bottom: 20px;
    display: flex;

    .ant-card-cover {
      img {
        height: 194px;
        width: 100%;
        object-fit: cover;
      }
    }
    .slick-track {
      display: flex;
    }

    .title {
      padding: 1em 0 0 0;

      h1 {
        font-size: 18px;
        margin: 0;
        padding: 4px 0 20px 0;
        line-height: 18px;
        font-weight: 600;
      }
    }

    .slick-dots {
      bottom: -24px;
    }
  }
`;
